import React, { FC, Fragment } from "react";
import { useTheme } from "styled-components";
import { classNames } from "helpers/themeHelpers";
import { IHome, IWidgetTypes } from "../../../types/home";
import { HomeListingCard } from "./styled.styles";
import { useIsCustomizeAds } from "../../../../../../hooks/useIsCustomizeAds";
import HomeWidgetImage from "./HomeWidgetImage";
import HomeWidgetText from "./HomeWidgetText";
import HomeWidgetTags from "./HomeWidgetTags";
import HomeWidgetTitle from "./HomeWidgetTitle";
import AdsBillBoardShimmer from "../../../../../../componentReusable/Ads/AdsBillBoard/AdsBillBoardShimmer";

interface IProps {
  homeData: IHome;
}

const HomeWidgets: FC<IProps> = ({ homeData }) => {
  const { isDesktop, isMobile } = useTheme();
  const isShowCustomizeAds = useIsCustomizeAds();
  const widgetAllowedTypes: IWidgetTypes[] = ["listings"];
  let counterIndex = [];
  homeData?.data?.widget?.forEach((w, index) => {
    if (w?.type === "listings" && w?.items?.length > 0) {
      counterIndex?.push(index);
    }
  });
  return (
    <Fragment>
      {homeData?.data?.widget?.map((widget, index) => {
        if (!widget?.items || widget?.items?.length === 0) return null;
        return (
          <Fragment key={index}>
            {index === 2 && isShowCustomizeAds && (
              <AdsBillBoardShimmer
                adName={
                  isDesktop
                    ? "homepage_middle_customized_leaderboard_desktop"
                    : "home_middle_customized_mpu_mobile"
                }
                className="m-auto"
              />
            )}
            {widgetAllowedTypes.includes(widget?.type) && (
              <HomeListingCard
                key={index}
                {...classNames(
                  `homeListingWidget homeWidget${widget.type}`,
                  isMobile && "whiteBg radius-8 mobileCardBorder",
                  isMobile && widget?.type === "listings" && "p-16",
                  isDesktop && "pb-16 mb-8",
                  isDesktop && widget?.type === "listings" && "pt-16",
                  isDesktop &&
                    widget?.type === "listings" &&
                    index !== counterIndex[0] &&
                    "borderTop"
                )}
              >
                {widget?.type === "listings" && (
                  <Fragment>
                    <HomeWidgetTitle widget={widget} />
                    <HomeWidgetTags widget={widget} />
                    {widget.view_type === "default" && (
                      <HomeWidgetImage widget={widget} />
                    )}
                    {widget.view_type === "no-image" && (
                      <HomeWidgetText widget={widget} />
                    )}
                  </Fragment>
                )}
              </HomeListingCard>
            )}
          </Fragment>
        );
      })}
    </Fragment>
  );
};
export default HomeWidgets;
